import { Screen } from '@epihub/web/src/routes/Screen';
import { privacyRoute } from '@krishanmadan/core/src/routes/frontendRoutes';

export const PrivacyScreen = Screen(privacyRoute, () => {
  window.location.href = 'https://www.iubenda.com/privacy-policy/15214437';
  return null;
});
